/**
 * Client-side platform-role check. Mirrors the server (src/lib/auth/roles.ts):
 * the Keycloak realm role that identifies Apex Pro staff in the shared apex-prod
 * realm. Keep this value in sync with PLATFORM_ROLE in src/config/index.ts.
 */
export const PLATFORM_ROLE = 'platform-ops';

/** Whether the user's realm roles include the platform-admin role. */
export function isPlatformAdmin(realmRoles?: string[]): boolean {
  return !!realmRoles?.includes(PLATFORM_ROLE);
}
